'use strict'

import { createXhr } from 'assets/core/js/common'
import tooltipV2, { setTooltipContent, updateTooltipPosition } from '@ui/Tooltip/component'

const cache: Record<string, string> = {}

const initTooltipWithUrl = (url: string, referenceEl: HTMLElement, tooltipEl: HTMLElement): void => {
  let contentUpdated = false
  let xhr: XMLHttpRequest | null = null

  if (!url) {
    return
  }

  const urlCache = cache[url]

  const tooltipCallbackShow = (): void => {
    if (contentUpdated || xhr !== null) {
      return
    }

    if (urlCache) {
      setTooltipContent(tooltipEl, urlCache)

      contentUpdated = true

      return
    }

    xhr = createXhr('GET', url)
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')

    xhr.onreadystatechange = async () => {
      try {
        if (xhr && xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
          const json = JSON.parse<{ html: string }>(xhr.response as string)
          setTooltipContent(tooltipEl, json.html)
          await updateTooltipPosition(referenceEl, tooltipEl)
          cache[url] = json.html

          contentUpdated = true
        }
      } catch (e) {}
    }

    xhr.send()
  }

  tooltipV2(referenceEl, tooltipEl, {
    callbackShow: tooltipCallbackShow,
  })
}

export default function (el: HTMLElement): void {
  const tooltipEl = el.querySelector<HTMLElement>('.dca-tooltip-v2') as HTMLElement

  if (!tooltipEl) {
    return
  }

  const referenceEl = el.querySelector<HTMLElement>(`[aria-describedby="${tooltipEl.id}"]`) as HTMLElement

  if (!referenceEl) {
    return
  }

  const url = el.getAttribute('data-url')

  if (url) {
    initTooltipWithUrl(url, referenceEl, tooltipEl)

    return
  }

  tooltipV2(referenceEl, tooltipEl)
}
